<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat tile class="elevation-2">
            <v-card v-if="giftCardsTransactionsListError" key="giftCardsTransactionsListErrorYes" class="pa-3">
              {{ giftCardsTransactionsListErrorMessage }}
            </v-card>

            <v-flex sm12>
              <v-layout row wrap>

                <v-flex pa-4 sm12 md2 lg2 left>
                  <v-card-title class="px-0">
                    Gift Card transactions
                  </v-card-title>
                </v-flex>

                <v-flex pa-4 sm12 md2 lg2 left>
                  <!-- <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field> -->
              </v-flex>
              
                <v-flex pa-4 sm12 md3 lg3 left>
                  <v-menu
                  :close-on-content-click="false"
                  v-model="filters.from.menu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="filters.from.date"
                      label="From"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="filters.from.date" @input="filters.from.menu = false"></v-date-picker>
                  </v-menu>
                </v-flex>

                <v-flex sm12 pa-4 md3 lg3 left>
                  <v-menu
                  :close-on-content-click="false"
                  v-model="filters.to.menu"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                  >
                
                    <v-text-field
                      slot="activator"
                      v-model="filters.to.date"
                      label="To"
                      prepend-icon="event"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="filters.to.date" @input="filters.to.menu = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                
                <v-flex pa-4 sm12 md2 lg2 text-xs-left left>
                  <v-btn color="primary" @click.prevent="filterByDate()" block>Search</v-btn>
                </v-flex>
              </v-layout>
            </v-flex> 


            <v-data-table
            v-if="$vuetify.breakpoint.smAndUp"
            :headers="headers"
            :items="allGiftCardsTransactions"
            :search="search"
            class="pa-3 tabulardata"
            >
            <tr slot="items" slot-scope="props" :class="props.item.type">
              <td class="text-xs-left">{{ props.item.note ? props.item.note : '-' }}</td>
              <td class="text-xs-left">{{ props.item.user_full_name }}</td>
              <td class="text-xs-left">{{ props.item.type }}</td>
              <td class="text-xs-left">{{ props.item.gift_card_number }}</td>
               <td class="text-xs-left">{{ props.item.amount }}</td>
               <td class="text-xs-left">{{ props.item.created_at }}</td>
            </tr>
            <v-alert slot="no-results" :value="true" color="error" icon="warning">
              Your search for "{{ search }}" found no results.
            </v-alert>
          </v-data-table>
          <v-data-iterator
            v-else
            :items="allGiftCardsTransactions"
            content-tag="v-layout"
            row
            wrap
            :search="search"
            class="pa-3"
          >
            <v-flex
              slot="item"
              slot-scope="props"
              xs12
              sm6
              md4
              lg3
            >
                <v-list-tile>
                  <v-list-tile-content>{{  props.item.note ? props.item.note : '-'}}</v-list-tile-content>
                </v-list-tile>
              <v-divider></v-divider>
              <v-list dense>
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.user_id }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.type }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.gift_card_id }}</v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>{{ props.item.amount }}</v-list-tile-content>
                </v-list-tile>
                 <v-list-tile>
                  <v-list-tile-content>{{ props.item.created_at }}</v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-flex>
          </v-data-iterator>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import axios from "axios";
import Env from "../environment";
import { mapActions, mapGetters } from 'vuex'
import AuthApi from './controllers/AuthApi';

export default {
  name: "UsersTransactions",
  props: {
    msg: String
  },
  data: () => ({
    search: "",
    filters: {
      active: false,
      from: {
        menu:'',
        date:''
      },
      to: {
        menu:'',
        date:''
      },
    },
    filteredGiftCardsTransactions: [],
    giftCardsTransactions: [],
    giftCardsTransactionsListError: false,
    giftCardsTransactionsListErrorMessage: "",
    headers: [
      { text: "Note", value: "note", },
      { text: "User", value: "user_full_name", },
      { text: "Type", value: "type", },
      { text: "Gift Card Token", value: "gift_card_number" },
      { text: "Amount", value: "amount", sortable: false,},
      { text: "Created at", value: "created_at", },
    ],
  }),
  computed: {
    allGiftCardsTransactions() {
      if(this.filters.active){
        return this.filteredGiftCardsTransactions;
      } else {
        return this.giftCardsTransactions;
      }
    },

  },
  watch: {
  },  
  created() {
    this.$emit("load");
    this.init();
  },
  mounted() {},
  methods: {
    /**
     * To get occasions and store it
     * @function
     * @returns {undefined}
     */
    init() {
      AuthApi.getApi(`${Env.giftcard_url}/api/transactions/giftcard_transactions/` + this.$route.params.giftcard_code)
        .then(res => {
          this.giftCardsTransactions = res.data.payload;
        })
        .then(() => {
          this.$emit("loadEnd");
        })
        .catch(err => {
          if (err.response.data.declaration === "auth_token_needs_refresh") {
            this.$emit("expire");
          } else if (err.response.data.declaration === "invalid_business") {
            this.giftCardTransactionsListError = true;
            this.giftCardTransactionsListErrorMessage = err.response.data.message;
            this.$emit("loadEnd");
          } else {
            console.log(err);
          }
        });
    },
    /**
     * Filter Transection by given from and to date
     * @function
     * @returns {undefined}
     */
    filterByDate() {
      if( !this.filters.from.date || !this.filters.to.date){
        alert('Please select from and to date.');
        return false;
      }
      this.$emit("showSpinner");
      AuthApi.getApi(`${Env.giftcard_url}/api/transactions/giftcard_transactions/` + this.$route.params.giftcard_code + '?from=' + this.filters.from.date + '&to=' + this.filters.to.date)
      .then((res) => {
        this.filters.active = true
        this.filteredGiftCardsTransactions = res.data.payload
        this.$emit("hideSpinner");
      }).catch(err => {
        this.$emit("hideSpinner");
         this.snackbar({
            text: 'Please try again later.',
            timeout: 5000,
            open: true
          })
      });
    },
    ...mapActions({
      snackbar: 'snackbar/snackbar'
    }),
  }
};
</script>
<style scoped>

</style>